import { FC } from 'react';
import { Skeleton } from '@mui/material';
import { MiniChartTile } from '../AnalyticsStyles';

interface Props {
  count?: number;
}

export const SkeletonTiles: FC<Props> = ({ count = 3 }) => (
  <>
    {Array.from({ length: count }, (_, i) => (
      <MiniChartTile key={i} sx={{ cursor: 'default', gridColumn: 'span 2', gridRow: 'span 2' }}>
        <Skeleton variant="text" width="60%" height={28} />
        <Skeleton variant="rectangular" height={280} sx={{ borderRadius: '8px' }} />
      </MiniChartTile>
    ))}
  </>
);
